export default __webpack_public_path__ + "static/media/le_lion7.b9c9fa90.jpg";